module.exports = __webpack_public_path__ + "static/media/horizontalIcon.1b559d8a.svg";